document.addEventListener("mousemove", event => {
    if (!document.body || !document.body.dataset)
        return;

    document.body.dataset.cursorY = event.clientY;
    document.body.dataset.cursorX = event.clientX;
});

export function getCursorPosition() {
    return {
        x: document.body.dataset.cursorX,
        y: document.body.dataset.cursorY
    }
}

export function getSafeBounds(width, height, offsetX = 0, offsetY = 0, padding = 10) {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    const safeX = Math.max(padding, Math.min(
        (parseFloat(document.body.dataset.cursorX) || 0) + offsetX,
        viewportWidth - width - padding
    ));

    const safeY = Math.max(padding, Math.min(
        (parseFloat(document.body.dataset.cursorY) || 0) + offsetY,
        viewportHeight - height - padding
    ));

    return {
        x: safeX,
        y: safeY
    };
}

export function getRelativePosition(element) {
    const padding = 5;
    const { top, left, width, height } = element.getBoundingClientRect();

    return {
        top: top + height + padding,
        left: left + padding
    }
}